module.exports = __webpack_public_path__ + "static/media/policy_settings_compliance_report.e502e5f8.svg";